module.exports = __webpack_public_path__ + "static/media/ines-forum-1.cb6e9b41.jpg";